import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: theme.spacing(140),
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: 0,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  actionButton: {
    margin: theme.spacing(3),
  },
  // TODO: 'actionButtons' referenced but not defined
  // TODO: 'closeButton' referenced but not defined
  saveButton: {
    backgroundColor: '#fc6161',
    color: '#fff',
  },
}));

const CardDelete = ({ visible, card, dismiss, confirm }) => {
  const classes = useStyles();
  const modalTitle = 'Delete Selected Item(s)?';
  return (
    <Modal
      className={classes.modal}
      open={visible}
      onClose={() => {
        dismiss();
      }}
    >
      <div className={classes.paper}>
        <IconButton
          className={classes.closeButton}
          disableRipple
          onClick={() => {
            dismiss();
          }}
        />
        <h2>{modalTitle}</h2>
        <span>
          <Typography>
            Deleting the credential(s) will permanently remove it from the system.
          </Typography>
          <Typography color="error">
            <b>This action cannot be undone.</b>
          </Typography>
        </span>
        <div className={classes.actionButtons}>
          <Button
            className={[classes.actionButton, classes.saveButton]}
            variant="contained"
            style={{ backgroundColor: '#f44336', color: '#fff' }}
            onClick={() => {
              confirm();
              dismiss();
            }}
          >
            Delete
          </Button>
          <Button
            className={classes.actionButton}
            onClick={() => {
              dismiss();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CardDelete;
